import { defineStore } from "pinia";

type EulaStoreState = {
  eulaAccepted: boolean;
};

export const useEulaStore = defineStore({
  id: "eula",
  state: () =>
    ({
      eulaAccepted: false
    }) as EulaStoreState,
  getters: {},
  actions: {
    setEulaAccepted() {
      this.eulaAccepted = true;
    },
    setEulaNotAccepted() {
      this.eulaAccepted = false;
    }
  }
});
